var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      staticClass: "modal-CouponListModal",
      attrs: {
        name: _vm.modalName,
        "show-close": true,
        "cover-closeable": false,
        "close-btn-handler": _vm.handleClose,
      },
      on: { modalClose: _vm.handleClose },
    },
    [
      _c(
        "div",
        {
          staticClass: "content",
          attrs: { slot: "modal-content" },
          slot: "modal-content",
        },
        [
          _c(
            "div",
            { staticClass: "tipDownBtn" },
            _vm._l(_vm.couponList, function (item, index) {
              return _c("div", {
                key: index,
                staticClass: "listStyle",
                style: {
                  backgroundImage: `url(${item})`,
                },
              })
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "upBackBtn" }, [
            _c("div", {
              staticClass: "jumpGasUrlBtn",
              on: { click: _vm.jumpGasUrl },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "jumpGasUrlTest" }, [
              _vm._v(
                _vm._s(
                  `用${_vm.myPhone}手机号登录高德app至-我的-钱包卡券-加油卡券`
                )
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }